<div class="pagecontent">
    <div class="headercontent">
        <h1 class="header1">Driver Information</h1>
        <h2 class="header2">Who was driving the vehicle?</h2>
        <p class="header3">
            <span>Please note: Consumers will receive the reimbursement, not the drivers</span>
        </p>
    </div>
    <div class="driver-content" formGroupName="tripRequest">
        @if (appointmentDatesFr.length > 1 || !tripRequestFg.get('isSameDriver')?.value) {
            <div class="form-field option-bottom-margin">
                <fieldset class="driver-radio-field">
                    <legend id="isSameDriverLabel">Is the driver same for all appointments</legend>
                    <mat-radio-group formControlName="isSameDriver" aria-labelledby="isSameDriverLabel">
                        <mat-radio-button [value]='true' aria-label="Yes, the same driver is used for all appointments">Yes</mat-radio-button>
                        <mat-radio-button [value]='false' aria-label="No, different drivers are used for appointments">No</mat-radio-button>
                    </mat-radio-group>
                </fieldset>
            </div>
        }   
        @if (tripRequestFg.get('isSameDriver')?.value) {        
            @if (!tripRequestFg.get('driverMannualEntry')?.value) {
                <div class="form-field">
                    <mat-label>Select Driver Name <span class="star">*</span></mat-label>
                    <mat-form-field>
                        <mat-select formControlName="driverId" placeholder="Select Driver" [errorStateMatcher]="matcher" (selectionChange)="driverSelectionChange($event)">
                        @for (driver of driverList$ | async; track driver.id) {
                            <mat-option [value]="driver.id">{{ driver.fullName }}</mat-option>
                        }
                        </mat-select>
                        @if (hasError('driverId', 'required')) {
                            <mat-error>This field is required.</mat-error>
                        }
                    </mat-form-field>
                    <span class="span-manual">Don't see your driver? <a tabindex="0" role="button" (click)="onEnterDriverManual($event, -1)">Enter the driver information</a></span>
                </div>
            }
            @else {
                <div class="form-field">
                    <label for="driverFirstName" >First Name <span class="star">*</span></label>
                    <mat-form-field appearance="outline">
                        <input id="driverFirstName" formControlName="driverFirstName" matInput placeholder="Enter First Name" [errorStateMatcher]="matcher" />
                        @if (hasError('driverFirstName', 'required')) {
                            <mat-error>This field is required.</mat-error>
                        }
                    </mat-form-field>
                </div>
                <div class="form-field">
                    <label for="driverLastName">Last Name <span class="star">*</span></label>
                    <mat-form-field appearance="outline">
                        <input id="driverFirstName" formControlName="driverLastName" matInput placeholder="Enter Last Name" [errorStateMatcher]="matcher" />
                        @if (hasError('driverLastName', 'required')) {
                            <mat-error>This field is required.</mat-error>
                        }
                    </mat-form-field>
                </div>
                <div class="driver-save">
                    <span class="span-list">Select Driver from <a tabindex="0" role="button" (click)="onEnterDriverfromList($event, -1)">List</a></span>
                    <mat-checkbox formControlName="saveDriverIntoProfile">Save Driver to Profile</mat-checkbox>
                </div>
            }
        }
        @if(!tripRequestFg.get('isSameDriver')?.value) {
            @for (date of appointmentDatesFr.controls; track date; let i = $index) {
                <div formArrayName="tripAppointments">   
                    <div class ="appointment-content" [formGroupName]="i" >
                        <span class="appointment-date">Appointment: {{date.get('appointmentDate')?.value | date: 'MM/dd/yyyy' }} at {{ date.get('appointmentDate')?.value | date: 'shortTime'}}</span>
                        @if (date.get('driverMannualEntry')?.value === false) {
                            <div class="form-field">
                                <label [for]="'driverId'+i">Select Driver Name</label>
                                <mat-form-field>
                                    <mat-select [id]="'driverId'+i" formControlName="driverId" placeholder="Select Driver" 
                                        [errorStateMatcher]="matcher" (selectionChange)="appointmentDriverSelectionChange($event, i)">
                                    @for (driver of driverList$ | async; track driver.id) {
                                        <mat-option [value]="driver.id">{{ driver.fullName }}</mat-option>
                                    }
                                    </mat-select>
                                    @if (hasError(`tripAppointments.${i}.driverId`, 'required')) {
                                        <mat-error>This field is required.</mat-error>
                                    }
                                </mat-form-field>
                                <span class="span-manual">Don't see your driver? <a tabindex="0" role="button" (click)="onEnterDriverManual($event,i)">Enter the driver information</a></span>
                            </div>
                        }
                        @else {
                            <div class="form-field">
                                <label [for]="'driverFirstName'+i">First Name <span class="star">*</span></label>
                                <mat-form-field appearance="outline">
                                    <input [id]="'driverFirstName'+i" formControlName="driverFirstName" matInput placeholder="Enter First Name" [errorStateMatcher]="matcher"/>
                                    @if (hasError(`tripAppointments.${i}.driverFirstName`, 'required')) {
                                        <mat-error>This field is required.</mat-error>
                                    }
                                </mat-form-field>
                            </div>
                            <div class="form-field">
                                <label [for]="'driverLastName'+i">Last Name <span class="star">*</span></label>
                                <mat-form-field appearance="outline">
                                    <input [id]="'driverLastName'+i" formControlName="driverLastName" matInput placeholder="Enter Last Name" [errorStateMatcher]="matcher" />
                                    @if (hasError(`tripAppointments.${i}.driverLastName`, 'required')) {
                                        <mat-error>This field is required.</mat-error>
                                    }
                                </mat-form-field>
                            </div>
                            <div class="driver-save">
                                <span class="span-list">Select Driver from <a tabindex="0" role="button" (click)="onEnterDriverfromList($event,i)">List</a></span>
                                <mat-checkbox formControlName="saveDriverIntoProfile">Save Driver to Profile</mat-checkbox>
                            </div>
                        }
                    </div>
                </div>
            }
        } 
    </div> 
</div>
